import { Module, Service, ServiceApiResult } from "../store/service/types";
import i18n from "./i18n";


export const nameTranslator = (s: Service | Module | undefined): string => {
    if (s === undefined) return '';

    switch ( i18n.language ) {
        case 'de':
            return s.name_de;
        default:
            return s.name_en;
    }
}